require("./scss/main.scss");
import Swiper from 'swiper/bundle';
import flatpickr from "flatpickr"
import Vue from 'vue'
import Wishlist from './wishlist'

import {
	Italian
} from "flatpickr/dist/l10n/it.js"

require("flatpickr/dist/plugins/rangePlugin");

window.calendar = function ($, id, defaultDate) {

	var it = require("flatpickr/dist/l10n/it").default.it;
	Italian.rangeSeparator = ',';
	var picker = flatpickr(id, {
		minDate: "today",
		altInput: true,
		altFormat: "d/m/y",
		dateFormat: "Y-m-d",
		monthSelectorType: 'static',
		mode: "range",
		locale: Italian,
		onClose: function (selectedDates, dateStr, instance) {

			var d1 = instance.formatDate(selectedDates[0], "d/m/y");
			var d2 = instance.formatDate(selectedDates[1], "d/m/y");

			$(".date-btn").removeClass("active");
			$(".date-btn.picker").addClass("active");
			$("#date-text").html(d1 + (d2 !== d1 ? ", " + d2 : ""));
			$(".date-btn.picker").closest("form").submit()
		},
		defaultDate: defaultDate
	});
	$(".picker").on('click', function () {
		picker.toggle();
	});

};

window.picker = function (id, config) {
	config = config || {
		minDate: "today",
		altInput: true,
		altFormat: "d/m/Y",
		dateFormat: "d/m/Y",
		monthSelectorType: 'static',
		locale: Italian
	}
	var it = require("flatpickr/dist/l10n/it").default.it;
	Italian.rangeSeparator = ',';
	return flatpickr(id, config);
};

let $ = window.$;
$(function () {
	$(".altrama-accordion").each(function (i, e) {
		var $this = $(e);
		var $title = $this.find(".title");
		$title.$content = $this.find(".altrama-accordion-content");
		$title.click(function () {
			$title.$content.slideToggle('slow');
		});
	});
});



window.init_gallery = function (selector, prev, next, cols) {
	var swiper = new Swiper(selector, {
		slidesPerView: 1,
		spaceBetween: 20,
		navigation: {
			nextEl: next,
			prevEl: prev,
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			790: {
				slidesPerView: Math.min(2, cols),
				spaceBetween: 20,
			},
			1032: {
				slidesPerView: cols,
				spaceBetween: 20,
			}
		}
	});
}



window.AltramaWishList = (function () {

	var listeners = [];
	let available = ('localStorage' in window && window['localStorage'] !== null);

	if (!available) {
		return false;
	}

	var wishlist = JSON.parse(localStorage.getItem("altrama-wishlist")) || [];

	function synch(do_reload, cb) {
		$.ajax({
			type: "POST",
			url: window.Altrama.settings.url + 'synch.php' ,//"/wp-admin/admin-ajax.php",
			data: { action: "updateWishlist", wishlist: wishlist },
			success: function (response) {			
				if( cb ) { cb(); }	
				if (do_reload && response.refresh === true) {
					return window.location.reload();
				}
			}
		});
	}
	function persist() {	
		localStorage.setItem("altrama-wishlist", JSON.stringify(wishlist));		
		synch(false, function(){				
			const event = new Event('wishlist');
			var stack = listeners.slice();
			for (var i = 0, l = stack.length; i < l; i++) {
				stack[i].call(null, event);
			}
		});
		
	}
	let obj = {
		addListener: function (callback) {
			listeners.push(callback);
		},
		removeListener: function (callback) {
			for (var i = 0, l = listeners.length; i < l; i++) {
				if (listeners[i] === callback) {
					listeners.splice(i, 1);
					return;
				}
			}
		},
		add: function (id, do_persist) {			
			if (!this.has(id)) {
				wishlist.push( Number(id) );				
				if(do_persist !== false ) persist();
			}
		},
		rem: function (id,do_persist) {
			id = Number(id);
			for (var i = 0, l = wishlist.length; i < l; i++) {				
				if(wishlist[i] === id){
					wishlist.splice(i, 1);
					if(do_persist !== false ) persist();
					return true;
				}		
			}
			if(do_persist !== false ) persist();
			return false;		
		},
		has: function (id) {
			id = Number(id);
			for (var i = 0, l = wishlist.length; i < l; i++) {	
				if(wishlist[i] == id) 
				return true;
			}
			return false;
		},
		toggle: function (id,do_persist) {
			let val = false;
			if (!this.rem(id,false)) {				
				this.add(id,false);
				val = true;
			}
			if(do_persist !== false ) persist();
			return val;
		},
		count() {
			return wishlist.length;
		},
		reset: function () {
			wishlist = [];
			persist();
		},
		list: function () { return [... wishlist]; }
	};

	synch(true); //Se in sessione non si trova la wishlist la settiamo e ricarichiamo.
	return obj;
})();

window.jQuery(function () {
	var $ = window.jQuery;
	var $counter = $(".count-holder .count");
	window.updateCounter = function() {
		if (window.AltramaWishList.count() > 0) {
			$counter.html(window.AltramaWishList.count());
			$counter.show();
		} else {
			$counter.hide();
		}
	}

	$(".wishChkBox  input[type='checkbox']").each(function (index, item) {
		let $item = $(item);
		let key = $item.val();
		$item.prop("checked", window.AltramaWishList.has( key ) );

		//console.info("item " + $item.val(), window.AltramaWishList.has(key) );
		$item.on("change", function (e) {
			let self = $(e.target);
			var id = self.val();
			var status = self.prop('checked');
			var title = self.attr('wishtitle');
			var type = self.attr('wishtype');
			if (status){
				window._paq.push(['trackEvent','Wishlist',type,title,1]);
			}
			else{
				window._paq.push(['trackEvent','Wishlist',type,title,-1]);
			}
			$item.prop("checked", window.AltramaWishList.toggle(id));
			window.updateCounter();
		});
	});

	window.updateCounter();
});


function render_component(component, id, name, dataValue) {
	let vm = new Vue({
		render: h => h(component, { props: { name: name, value: dataValue } })
	});
	vm.$mount(id);
}

window.render_wishlist = function (id, name, dataValue) {
	return render_component(Wishlist, id, name, dataValue);
}